import React from "react";
import styles from "../WidgetAppearanceForm.module.css";
import {
    AppearanceTabSettingsContainer
} from "../../../../../../../elements/appearanceTabSettingsContainer/AppearanceTabSettingsContainer";
import {useAppDispatch} from "../../../../../../../../app/hooks";
import {ValidatedInputField} from "../../../../../../../elements/validator/component/ValidatedInputField";
import {ValidatedTextAreaField} from "../../../../../../../elements/validator/component/ValidatedTextAreaField";
import {
    ASSISTANT_NAME_MAX_LENGTH,
    AssistantNameValidator,
    PERSONA_PROMPT_MAX_LENGTH,
    PersonaPromptValidator
} from "../../../../../../../elements/validator/Validator";
import {
    DEFAULT_ASSISTANT_NAME,
    selectAssistantName,
    selectPersonaPrompt,
    updateSettings
} from "../../../widgetAppearanceUpdateSlice";

interface AssistantPersonaProps {
    getMessageWrapper: (field: string) => string;
    updateValidationStatus: any;
}

export const AssistantPersona: React.FC<AssistantPersonaProps> = ({getMessageWrapper, updateValidationStatus}) => {
    const dispatch = useAppDispatch();

    return (
        <AppearanceTabSettingsContainer title="Assistant Persona">
            <div className={styles.fieldsLine}>
                <ValidatedInputField
                    onChange={(v: string) => dispatch(updateSettings({
                        assistantName: v
                    }))}
                    updateValidationStatus={updateValidationStatus}
                    fieldName="assistantName"
                    selector={selectAssistantName}
                    validator={AssistantNameValidator}
                    label="Assistant Name"
                    placeholder={DEFAULT_ASSISTANT_NAME}
                    maxLength={ASSISTANT_NAME_MAX_LENGTH}
                    getMessage={getMessageWrapper}
                />
            </div>
            <div className={styles.fieldsLine}>
                <ValidatedTextAreaField
                    onChange={(v: string) => dispatch(updateSettings({
                        personaPrompt: v
                    }))}
                    updateValidationStatus={updateValidationStatus}
                    fieldName="personaPrompt"
                    selector={selectPersonaPrompt}
                    validator={PersonaPromptValidator}
                    label="Persona"
                    maxLength={PERSONA_PROMPT_MAX_LENGTH}
                    placeholder="Describe how the assistant comes across: formality, tone, age, gender."
                    getMessage={getMessageWrapper}
                />
            </div>
        </AppearanceTabSettingsContainer>
    );
};
